import React from 'react';

const legalLink = { background: 'none', border: 'none', color: '#C9A84C', cursor: 'pointer', padding: 0, fontSize: 'inherit', textDecoration: 'underline' };
const checkStyle = { accentColor: '#C9A84C', width: '15px', height: '15px', marginTop: '2px' };
const labelText = { fontSize: '11px', color: '#C2C1B6', lineHeight: 1.5 };

export const ConsentBlock = ({ prefix, terms, setTerms, marketing, setMarketing, onShowTerms, onShowPrivacy }) => (
  <>
    <label className="flex items-start gap-2 cursor-pointer" data-testid={`${prefix}-marketing-label`}>
      <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} style={checkStyle} data-testid={`${prefix}-marketing`} />
      <span className="font-body" style={labelText}>Quiero recibir ofertas y novedades por email</span>
    </label>
    <label className="flex items-start gap-2 cursor-pointer" data-testid={`${prefix}-terms-label`}>
      <input type="checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)} style={checkStyle} data-testid={`${prefix}-terms`} />
      <span className="font-body" style={labelText}>
        Acepto los <button type="button" onClick={onShowTerms} style={legalLink} data-testid={`${prefix}-terms-link`}>Términos de Uso</button> y la <button type="button" onClick={onShowPrivacy} style={legalLink} data-testid={`${prefix}-privacy-link`}>Política de Privacidad</button>
      </span>
    </label>
  </>
);
